import {Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild} from '@angular/core';
import {IrbEditorsService} from "@irb/irb-editors/irb-editors.service";
import {CalltoactionService} from "@irb-common/components/calltoaction/calltoaction.service";
import {
  PortfolioEquivalentsGridLayoutService
} from "@irb/irb-editors/editor-portfolio/portfolio-equivalents-alternatives/portfolio-equivalents-grid-layout.service";
import {
  ICustomSecurity,
  ISecurities
} from "@irb/irb-editors/irb-editors.model";
import {IDropdownItem} from "@irb-common/models/dropdown.model";
import {UtilityService} from "@irb-common/services/utility.service";
import {DropdownFilterComponent} from "@irb-common/components/dropdown-filter/dropdown-filter.component";
import {IrbModelsEvents} from "@irb/irb-models/irb-models.events";
import {AppService} from "@irb/app.service";
import {ISecurityCustomCategory} from "@irb/irb-models/irb-models.model";
import {IEvent, IrbSettingsEvents} from "@irb-common/events";
import {Subscription} from "rxjs";


@Component({ standalone: false,
  selector: 'irb-portfolio-equivalents-alternatives',
  templateUrl: './portfolio-equivalents-alternatives.component.html',
  styleUrl: './portfolio-equivalents-alternatives.component.scss'
})
export class PortfolioEquivalentsAlternativesComponent implements OnInit, OnDestroy {

  @Output() change = new EventEmitter<any>();
  @Input() data: any;
  @Output() viewPortfolioModelOut = new EventEmitter<any>();

  @ViewChild('securitiesDropdownEl') securitiesDropdownEl: any;
  @ViewChild("securityEquivalentsDropdown") securityEquivalentsDropdown: any;
  @ViewChild("categoryEquivalentsDropdown") categoryEquivalentsDropdown: any;
  @ViewChild("selectTypeDropdown") selectTypeDropdown: any;

  frameworkComponents: any;
  gridOptions: any;
  grid: any;
  isUiTest = false;
  gridHeight: string;
  heldCount = 0;
  securityCount = 0;
  categoryCount = 0;
  securities: ISecurities;
  selectedTargetSecurity: any;
  equivalentCategories: Array<ISecurityCustomCategory> = [];
  customCategoriesDropdownData: Array<IDropdownItem> = [];
  equivalentType = 'security';
  equivalentSecurities: Array<ICustomSecurity> = [];
  equivalentSecuritiesDropdownData: Array<IDropdownItem> = [];
  selectedCustomCategory: Array<IDropdownItem>;
  selectedEquivalentSecurity: Array<IDropdownItem>;
  isAddButtonDisabled = true;
  altIfHeld = false;
  isAltIfHeldDisabled = false;
  modelId: string;
  cashObject: IDropdownItem;
  addNewPfEquivalentSecurityItem: any = {
    button: 'Add new security',
    type: 'security',
    noRefresh: true,
    fromComp: 'ComPfSecurityEquivalentsComponent'
  };
  addNewPfTargetEquivalentSecurityItem: any = {
    button: 'Add new security',
    type: 'security',
    noRefresh: true,
    fromComp: 'ComPfTargetSecurityEquivalentsComponent'
  };
  addNewPfCategoryItem: any = {
    button: 'Add new category',
    type: 'assetCategory',
    fromComp: 'PortfolioEquivalentsAlternativesComponent'
  };
  typeDropdownSelected: IDropdownItem = {name: 'Security', value: 'security'};

  private eventSubscription: Subscription;

  constructor(private ies: IrbEditorsService,
              private util: UtilityService,
              private ctas: CalltoactionService,
              private as: AppService,
              private gls: PortfolioEquivalentsGridLayoutService) {

    this.frameworkComponents = this.gls.getFrameworkComponents();

    this.gridOptions = {
      columnDefs: this.gls.getColumnDefs(this),
      floatingFilter: false,
      overlayNoRowsTemplate:
          `<span class='ag-overlay-loadGriding-center ag-overlay-message'>
            <strong>No Portfolio-Specific Equivalents or Alternatives Configured</strong><br>
            You can configure equivalents and alternatives to your securities to include in this list.
            </span>`,
      context: {componentParent: this},
      isExternalFilterPresent: this.isExternalFilterPresent.bind(this),
      doesExternalFilterPass: this.doesExternalFilterPass.bind(this),
      suppressHorizontalScroll: true
    }

    this.ies.getSecuritiesSearchDropDown("$CASH").subscribe((cashObj: any) => {
      this.cashObject = cashObj.items[0]; // {value: 87318, name: "$CASH"}
    });
  }

  ngOnInit(): void {
    this.eventSubscription = this.as.getEvents().subscribe((s) => {
      this.processEvent(s);
    });
    this.data = this.data || {};
    this.modelId = this.data.securityModelId;
    this.data.portfolioEquivalents = this.data.portfolioEquivalents || [];
    this.loadDropDawnsData();
  }

  private processEvent(event: IEvent) {
    switch (event.type) {
      case IrbModelsEvents.SAVE_MASTER_MULTIPLE_SECURITY:
        if (event.data && event.data.type === 'editPortfolioEquivalents') {
          this.addEquivalentsFromMaster(event.data);
        }
        break;
      case IrbModelsEvents.SAVE_CREATE_NEW_SECURITY:
        if (event.data) {
          if (event.data.type === 'security' && event.data.fromComp === 'ComPfTargetSecurityEquivalentsComponent') {
            this.resetTargetSecuritySearch(event.data)
          }
          if (event.data.type === 'security' && event.data.fromComp === 'ComPfSecurityEquivalentsComponent') {
            this.resetEquivalentSecuritySearch(event.data)
          }
        }
        break;
      case IrbSettingsEvents.ASSET_CATEGORY_UPDATED:
        if (event.data) {
          if (event.data.type === 'assetCategory' && event.data.fromComp === 'PortfolioEquivalentsAlternativesComponent') {
            this.resetCategorySearch(event.data)
          }
        }
        break;
    }
  }

  isExternalFilterPresent() {
    return true;
  }

  doesExternalFilterPass(node: any) {
    return !node.data.isUIdeleted;
  }

  onGridReady(params: any) {
    this.grid = params;
    this.loadGrid();
  }

  private loadGrid() {
    if (this.grid && this.grid.api && this.data.portfolioEquivalents) {
      this.grid.api.setGridOption('rowData', this.data.portfolioEquivalents);
      this.heldCount = this.data.portfolioEquivalents.filter((x: any) => !x.isUIdeleted && x.altIfHeldFlag).length;
      this.securityCount = this.data.portfolioEquivalents.filter((x: any) => !x.isUIdeleted && x.eqSecurityType !=='CustCat' && !x.altIfHeldFlag).length;
      this.categoryCount = this.data.portfolioEquivalents.filter((x: any) => !x.isUIdeleted && x.eqSecurityType ==='CustCat').length;
      this.updateGridHeight();
    }
  }

  loadDropDawnsData() {
    this.getAllTargetSecurities();
    this.getAllCategories();
    this.getAllEquivalents();
  }

  private getAllTargetSecurities() {
    this.ies.getSecurities().subscribe((data: ISecurities) => {
      this.securities = data;

      if (this.securities) {
        this.util.sortByKey(this.securities.items, "securitySymbol", "asc");
      }
    });
  }

  private getAllCategories() {
    this.ies.getCustomCategories().subscribe((categories: any) => {
      this.equivalentCategories = categories.items;
      if (categories.items && categories.items.length > 0) {
        categories.items = categories.items.filter((x: any) => x.custCatId !== 0);// eliminate uncategorized
      }
      this.customCategoriesDropdownData = [];
      categories.items.forEach((item: ISecurityCustomCategory) => {
        this.customCategoriesDropdownData.push({
          name: item.custCatName,
          value: item.custCatId
        } as IDropdownItem);
      });

      this.util.sortByKey(this.customCategoriesDropdownData, "name", "asc");
      this.customCategoriesDropdownData = this.getDistinctCategories(this.customCategoriesDropdownData);
    });
  }

  private getAllEquivalents() {
    this.ies.getAllSecuritiesForAllEqv('0').subscribe((securityEquivalentsResponse: any) => {
      this.equivalentSecurities = securityEquivalentsResponse.items as Array<ICustomSecurity>;

      if (this.equivalentSecurities && this.equivalentSecurities.length > 0) {
        this.equivalentSecuritiesDropdownData = [];
        this.equivalentSecurities.forEach((item: any) => {
          this.equivalentSecuritiesDropdownData.push({
            name: item.securitySymbol,
            value: item.securityId
          } as IDropdownItem);
        });

        this.util.sortByKey(this.equivalentSecuritiesDropdownData, "name", "asc");
      }
    });
  }

  private getDistinctCategories(categories: IDropdownItem []) {
    const distinctCategories: IDropdownItem [] = [];

    if (categories && categories.length > 0) {
      categories.forEach((x: IDropdownItem) => {
        if (x.name
            && distinctCategories.findIndex(y => x.name === y.name) === -1) {
          distinctCategories.push(x);
        }
      });
    }

    return distinctCategories;
  }

  populateTargetSecurities(searchString: string): void {
    if (searchString && searchString.length > 0) {
      const filteredItems = DropdownFilterComponent.getFilteredList(searchString, this.securities.items
          .map((security: ICustomSecurity) => ({
            name: security.securitySymbol,
            value: security.securityId
          })));
      this.securitiesDropdownEl.set(filteredItems);
    }
  }

  selectTargetSecurity(selectedSecurity?: any): void {
    const security = this.securities.items.filter((sec: any) => sec.securityId === selectedSecurity.value)[0];
    this.selectedTargetSecurity = security;
    this.enableDisableAddButton();
  }

  clearTargetSecurity(): void {
    this.selectedTargetSecurity = null;
    this.enableDisableAddButton();
  }



  deleteAll() {
    this.data.portfolioEquivalents.forEach((x: any) => {
      x.isUIdeleted = true;
    });
    this.data.portfolioEquivalents = this.data.portfolioEquivalents.filter((x: any) => !x.isNew);
    this.reLoadData();
  }

  delete(cc: any) {
    let deletedItem;
    if (cc.equivalentSecurityId)
      deletedItem = this.data.portfolioEquivalents.find((x: any) => x.equivalentSecurityId === cc.equivalentSecurityId && x.securityId === cc.securityId);
    else
      deletedItem = this.data.portfolioEquivalents.find((x: any) => x.equivalentCategoryId === cc.equivalentCategoryId && x.securityId === cc.securityId);
    if (deletedItem) {
      deletedItem.isUIdeleted = true;
      this.data.portfolioEquivalents = this.data.portfolioEquivalents.filter((x: any) => !(x.isUIdeleted && x.isNew));
      this.reLoadData();
    }
  }

  cancelDelete() {
    this.ctas.remove();
  }

  getRowCount() {
    return this.data.portfolioEquivalents ? this.data.portfolioEquivalents.length : 0;
  }


  updateGridHeight() {
    const tr = this.grid?.api.getDisplayedRowCount() || 0;

    if (tr === 0) {
      this.gridHeight = "150px";
      this.grid.api.setGridOption('domLayout', 'normal');
    } else if (tr > 6) {
      this.gridHeight = "280px";
      this.grid.api.setGridOption('domLayout', 'normal');
    } else {
      this.gridHeight = "100%";
      this.grid.api.setGridOption('domLayout', 'autoHeight');
    }
  }

  viewPortfolioModel() {
    this.viewPortfolioModelOut.emit();
    // const isBlended = this.modelId.toLowerCase().endsWith("b");
    // let slideData: any =  {};
    // slideData.slot ="B";
    // slideData.isDraft = false;
    //
    // if (isBlended) {
    //   let mid = this.modelId.replace('b','').replace('B','');
    //   slideData.blendedSecurityModelId = mid;
    //   slideData.modelId = mid;
    //   slideData.type = 'Blended';
    // } else {
    //   slideData.modelId = this.modelId;
    //   slideData.type = 'Base';
    // }
    // this.as.fireEvent(IrbModelsEvents.SHOW_EDIT_MODEL, slideData);
  }

  setEquivalentType(event: IDropdownItem) {
    this.typeDropdownSelected = event;
    this.equivalentType = this.typeDropdownSelected.value;
    this.isAltIfHeldDisabled = this.equivalentType === 'security' ? false : true;
    // Clear the Alt If Held checkbox if it is disabled
    if (this.isAltIfHeldDisabled) {
        this.altIfHeld = false; // Reset the checkbox state
    }
    this.enableDisableAddButton();
  }

  populateSecurityEquivalentsMultiple(searchString: string) {
    let filteredData = this.equivalentSecuritiesDropdownData;
    
    // Filter out the target security to eliminate current target if exists
    if (this.selectedTargetSecurity) {
      filteredData = this.equivalentSecuritiesDropdownData.filter((item: any) => 
        item.value !== this.selectedTargetSecurity.securityId
      );
    }
    
    this.securityEquivalentsDropdown.set(DropdownFilterComponent.getFilteredList(searchString, filteredData));
  }

  onSelectSecurityEquivalents(selections: Array<IDropdownItem>) {
    this.selectedEquivalentSecurity = selections;
    this.enableDisableAddButton();
  }

  populateCategoryEquivalentsMultiple(searchString: string) {
    this.categoryEquivalentsDropdown.set(DropdownFilterComponent.getFilteredList(searchString,this.customCategoriesDropdownData));
  }

  onSelectCategoryEquivalents(selections: Array<IDropdownItem>) {
    this.selectedCustomCategory = selections;
    this.enableDisableAddButton();
  }

  showAddMultipleSecuritiesDialog() {
    let dataInputForMultipleSelection:any=[];
    this.grid.api.forEachNode((node:any)=> {
      if (this.selectedTargetSecurity && this.selectedTargetSecurity.securityId === node.data.securityId)
        dataInputForMultipleSelection.push(node.data);
    });
    const newItem = {
      altIfHeldFlag: false,
      eqSecurityDescription: this.selectedTargetSecurity?.securityDescription,
      eqSecuritySymbol: this.selectedTargetSecurity?.securitySymbol,
      eqSecurityType: this.selectedTargetSecurity?.securityType,
      equivalentSecurityId: this.selectedTargetSecurity?.securityId,
      securityId: this.selectedTargetSecurity?.securityId
    };
    dataInputForMultipleSelection.push(newItem);

    const cashItem : any = {
      altIfHeldFlag: false,
      eqSecurityDescription: this.cashObject?.name,
      eqSecuritySymbol: this.cashObject?.name,
      eqSecurityType: 'CASH',
      equivalentSecurityId: this.cashObject?.value,
      securityId: this.cashObject?.value
    }
    dataInputForMultipleSelection.push(cashItem);

    const params: any = {
      type: 'editPortfolioEquivalents',
      dialogTitle: 'Add Multiple Equivalents to this Portfolio',
      securitySymbol: null,
      data:dataInputForMultipleSelection,
      field: "equivalentSecurityId"

    };
    this.as.fireEvent(IrbModelsEvents.SHOW_MASTER_MULTIPLE_SECURITY, params);
  }

  onAddEquivalent() {
    let listOfEquivalents: any = [], rec: any;
    if (this.equivalentType === 'security' && this.selectedEquivalentSecurity?.length) {
      this.selectedEquivalentSecurity.forEach((eqv: any) => {
        let equivalent: any = this.equivalentSecurities.find((sec: any) => sec.securityId === eqv.value);
        let duplicate: any = this.data.portfolioEquivalents.find((x: any) => this.selectedTargetSecurity.securityId === x.securityId &&  x.equivalentSecurityId === equivalent.securityId && x.isUIdeleted === false);
        if (equivalent && !duplicate) {
          let deletedItem = this.data.portfolioEquivalents.find((x: any) => this.selectedTargetSecurity.securityId === x.securityId && x.equivalentSecurityId === equivalent.securityId && x.isUIdeleted === true);
          if (deletedItem) {
            deletedItem.isUIdeleted = false;
            deletedItem.altIfHeld = this.altIfHeld;
          } else {
            rec = {
              portfolioId: this.data.portfolioId,
              targetSecuritySymbol: this.selectedTargetSecurity.securitySymbol,
              securityDescription: this.selectedTargetSecurity.securityDescription,
              securityId: this.selectedTargetSecurity.securityId,
              equivalentSecurityId: equivalent.securityId,
              isNew: true,
              isUIdeleted: false,
              eqSecuritySymbol: equivalent.securitySymbol,
              eqSecurityType: equivalent.securityType,
              eqSecurityDescription: equivalent.securityDescription,
              altIfHeldFlag: this.altIfHeld,
              equivalentCategoryId: null
            }
            listOfEquivalents.push(rec);
          }
        }
      });
      this.selectedEquivalentSecurity = null;
    } else if (this.equivalentType === 'category' && this.selectedCustomCategory?.length) {
      this.selectedCustomCategory.forEach((cat: any) => {
        let eqCat: any = this.equivalentCategories.find((eqv: any) => eqv.custCatId === cat.value);
        let duplicate: any = this.data.portfolioEquivalents.find((x: any) => this.selectedTargetSecurity.securityId === x.securityId &&  x.equivalentCategoryId === cat.value && x.isUIdeleted === false);
        if (eqCat && !duplicate) {
          let deletedItem = this.data.portfolioEquivalents.find((x: any) => this.selectedTargetSecurity.securityId === x.securityId && x.equivalentCategoryId === cat.value && x.isUIdeleted === true);
          if (deletedItem) {
            deletedItem.isUIdeleted = false;
          } else {
            rec = {
              portfolioId: this.data.portfolioId,
              targetSecuritySymbol: this.selectedTargetSecurity.securitySymbol,
              securityDescription: this.selectedTargetSecurity.securityDescription,
              securityId: this.selectedTargetSecurity.securityId,
              equivalentSecurityId: null,
              isNew: true,
              isUIdeleted: false,
              eqSecuritySymbol: cat.name,
              eqSecurityType: 'CustCat',
              eqSecurityDescription: eqCat.custCatDesc,
              altIfHeldFlag: false,
              equivalentCategoryId: cat.value
            }
            listOfEquivalents.push(rec);
          }
        }
      });
      this.selectedCustomCategory = null;
    }

    this.data.portfolioEquivalents.push(...listOfEquivalents);
    this.reLoadData();
  }

  addEquivalentsFromMaster(eventData: any) {
    if (eventData.selectedSecurities && eventData.selectedSecurities.length) {
      eventData.selectedSecurities.forEach((newSecurity: any) => {
        let duplicate: any = this.data.portfolioEquivalents.find((x: any) => this.selectedTargetSecurity.securityId === x.securityId &&  x.equivalentSecurityId === newSecurity.securityId && x.isUIdeleted === false);
        if (!duplicate) {
          let deletedItem = this.data.portfolioEquivalents.find((x: any) => this.selectedTargetSecurity.securityId === x.securityId && x.equivalentSecurityId === newSecurity.securityId && x.isUIdeleted === true);
          if (deletedItem) {
            deletedItem.isUIdeleted = false;
            deletedItem.altIfHeld = this.altIfHeld;
          } else {
            this.data.portfolioEquivalents.push({
              portfolioId: this.data.portfolioId,
              targetSecuritySymbol: this.selectedTargetSecurity.securitySymbol,
              securityDescription: this.selectedTargetSecurity.securityDescription,
              securityId: this.selectedTargetSecurity.securityId,
              equivalentSecurityId: newSecurity.securityId,
              isNew: true,
              isUIdeleted: false,
              eqSecuritySymbol: newSecurity.securitySymbol,
              eqSecurityType: newSecurity.securityType,
              eqSecurityDescription: newSecurity.securityDescription,
              altIfHeldFlag: this.altIfHeld,
              equivalentCategoryId: null
            });
          }
        }
      });
      this.reLoadData();
    }
  }

  enableDisableAddButton() {
    if (!this.selectedTargetSecurity)
        this.isAddButtonDisabled = true;
    else
      this.isAddButtonDisabled = false;

    if (this.equivalentType === 'security' && !this.selectedEquivalentSecurity)
      this.isAddButtonDisabled = true;
    else if (this.equivalentType === 'category' && !this.selectedCustomCategory)
      this.isAddButtonDisabled = true;
    
    // Disable if any selected equivalent security is the same as target security
    if (this.equivalentType === 'security' && this.selectedTargetSecurity && this.selectedEquivalentSecurity) {
      const hasSameAsTarget = this.selectedEquivalentSecurity.some((eqv: any) => 
        eqv.value === this.selectedTargetSecurity.securityId
      );
      if (hasSameAsTarget) {
        this.isAddButtonDisabled = true;
      }
    }
  }

  reLoadData() {
    this.loadGrid();
    this.enableDisableAddButton();
    this.data.isPortfEqvModified = true; 
    this.change.emit(this.data);
  }

  onAltIfHeldCheckboxChanged(params: any, event: any, _rowIndex?: any) {
    let equivalentPresent: any = this.data.portfolioEquivalents.find((x: any) => params.securityId === x.securityId &&  x.equivalentSecurityId === params.equivalentSecurityId && x.isUIdeleted === false);
    equivalentPresent.altIfHeldFlag = event;
    this.reLoadData();
  }

  openNewTargetSecurityFlow(dataParam: any) {
    dataParam = Object.assign({}, this.addNewPfTargetEquivalentSecurityItem, dataParam);
    dataParam.editSecurity = true;
    this.as.fireEvent(IrbModelsEvents.SHOW_CREATE_SECURITIES, dataParam);
  }

  openNewEquivalentSecurityFlow(dataParam: any) {
    dataParam = Object.assign({}, this.addNewPfEquivalentSecurityItem, dataParam);
    dataParam.editSecurity = true;
    this.as.fireEvent(IrbModelsEvents.SHOW_CREATE_SECURITIES, dataParam);
  }

  openNewPfCategoryFlow(dataParam: any) {
    dataParam = Object.assign({}, this.addNewPfCategoryItem, dataParam);
    this.as.setToLocal("LAST_TAB_INDEX", 0);
    this.as.fireEvent(IrbSettingsEvents.SHOW, dataParam);
  }

  resetTargetSecuritySearch(dataParam: any) {
    if (dataParam && dataParam.newItemsForDD && dataParam.newItemsForDD.length !== 0) {
      if (dataParam.securities && dataParam.securities.responseData) {
        if (dataParam.securities.responseData.length) {
          this.securities.items = this.securities.items.concat(dataParam.securities.responseData);
          this.util.sortByKey(this.securities.items, "securitySymbol", "asc");
          this.equivalentSecurities = this.equivalentSecurities.concat(dataParam.securities.responseData);
          this.equivalentSecuritiesDropdownData.concat(dataParam.newItemsForDD);
        }
      }
      if (this.securitiesDropdownEl && this.securitiesDropdownEl.setValue)
        this.securitiesDropdownEl.setValue(dataParam.newItemsForDD[0]);
      this.selectTargetSecurity(dataParam.newItemsForDD[0]);
    }
  }

  resetEquivalentSecuritySearch(dataParam: any) {
    if (dataParam && dataParam.newItemsForDD && dataParam.newItemsForDD.length !== 0) {
      if (dataParam.securities && dataParam.securities.responseData) {
        if (dataParam.securities.responseData.length) {
          this.equivalentSecurities = this.equivalentSecurities.concat(dataParam.securities.responseData);
          this.securities.items = this.securities.items.concat(dataParam.securities.responseData);
          this.util.sortByKey(this.securities.items, "securitySymbol", "asc");
        }
      }
      this.equivalentSecuritiesDropdownData.concat(dataParam.newItemsForDD);
      this.util.sortByKey(this.equivalentSecuritiesDropdownData, "name", "asc");
      if (dataParam.newItemsForDD && dataParam.newItemsForDD.length !== 0) {
        if (this.securityEquivalentsDropdown && this.securityEquivalentsDropdown.setValue)
          this.securityEquivalentsDropdown.setValue(dataParam.newItemsForDD);
      }
      this.onSelectSecurityEquivalents(dataParam.newItemsForDD);
      this.getAllEquivalents();
    }
  }

  resetCategorySearch(dataParam: any) {
    if (dataParam && dataParam.newItems && dataParam.newItems.length !== 0) {
      this.customCategoriesDropdownData = this.customCategoriesDropdownData.concat(dataParam.newItemsForDD);
      this.equivalentCategories = this.equivalentCategories.concat(dataParam.newItems);
      this.util.sortByKey(this.customCategoriesDropdownData, "name", "asc");
      if (dataParam.newItemsForDD && dataParam.newItemsForDD.length !== 0) {
        if (this.categoryEquivalentsDropdown && this.categoryEquivalentsDropdown.setValue)
          this.categoryEquivalentsDropdown.setValue(dataParam.newItemsForDD);
        this.selectedCustomCategory = dataParam.newItemsForDD;
        this.enableDisableAddButton();
      }
    }
  }

  populateTypeDropdown(searchStr: string) {
    const listOfTypes: Array<IDropdownItem> = [
      {name: 'Security', value: 'security'},
      {name: 'Category', value: 'category'}
    ];
    const f = DropdownFilterComponent.getFilteredList( searchStr, listOfTypes);
    this.selectTypeDropdown.set(f);
  }

  ngOnDestroy(): void {
    if (this.eventSubscription) {
      this.eventSubscription.unsubscribe();
    }
  }
}
